import { render } from "./UserBadge.vue?vue&type=template&id=2f0529d8"
import script from "./UserBadge.vue?vue&type=script&lang=js"
export * from "./UserBadge.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__